import React, { Children } from 'react';
import { Navigation } from './Navigation';
import { Footer } from './Footer';
import { ScrollToTop } from './ScrollToTop';
import { CustomCursor } from './CustomCursor';
import { AnimatedSection } from './AnimatedSection';
import { ContactModal } from './ContactModal';
interface LayoutProps {
  children: ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col relative" data-id="element-100">
      <ScrollToTop data-id="element-101" />

      <CustomCursor data-id="element-102" />
      <ContactModal data-id="element-103" />
      <Navigation data-id="element-104" />
      <main className="flex-grow relative z-10" data-id="element-105">{children}</main>
      {/* Image Strip — Before Footer */}
      <div className="relative z-10" data-id="element-106">
        <AnimatedSection data-id="element-107">
          <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-108">
            <div className="overflow-hidden" data-id="element-109">
              <img src="https://cdn.magicpatterns.com/uploads/svuqCvjzYKpdsqKhxyHAry/DSCN3897.jpg" alt="Children smiling in a Southeast Asian community" className="w-full h-64 md:h-80 object-cover" data-id="element-110" />
            </div>
            <div className="overflow-hidden" data-id="element-111">
              <img src="https://cdn.magicpatterns.com/uploads/mkZE6qihPVdec631fiWWkN/FromTerri_Cambodia6.jpg" alt="Rice fields in Cambodia" className="w-full h-64 md:h-80 object-cover" data-id="element-112" />
            </div>
          </div>
        </AnimatedSection>
      </div>
      <Footer data-id="element-113" />
    </div>;
}